import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { LabelPlacement } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class LabelPlacementService extends TmsWebBaseEditService<LabelPlacement, LabelPlacement> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('LabelPlacement', $localize`Label Placement`, httpService, notificationService);
  }
}
